import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormControl from 'react-bootstrap/lib/FormControl';

import t from '../../../lib/I18n';
import trainTime from '../../../lib/TrainTime';
import MomentPropTypes from "../../../helpers/MomentPropTypes";
import { hours } from './HourSelector';
import { minutes, roundMinutes } from './MinuteSelector';

import Icon from '../../general/Icon';

const TIME_FORMAT = 'HH:mm';

function CombinedTimeSelector ({ datetime, minuteStep, onChange, disabled, min, max, ariaLabel }) {
    const roundedDatetime = datetime.clone().minute(roundMinutes(datetime.minute(), minuteStep));
    const [value, setValue] = useState(roundedDatetime);
    const uniqueId = _.uniqueId('time__selector_');

    const changeHandler = callback => e => {
        const timeStr = e.target.value;
        const time = trainTime(timeStr, TIME_FORMAT);
        const updatedDatetime = roundedDatetime.clone().set({
            hour: time.hour(),
            minute: time.minute()
        });
        setValue(updatedDatetime);
        callback(updatedDatetime);
    };

    return (
        <div className="time select-container">
            <Icon icon="dropdown" />

            <label htmlFor={ uniqueId } className="sr-only">
                {ariaLabel ? `${ariaLabel} ${value.format(TIME_FORMAT)}` : t('booking.time.labels.time')}
            </label>

            <FormControl
                componentClass="select"
                disabled={ disabled }
                name="time"
                id={ uniqueId }
                className="time__form-control"
                value={ value.format(TIME_FORMAT) }
                onChange={ changeHandler(onChange) }
            >
                {hours.map(hour =>
                    minutes(minuteStep).map(minute => {
                        const time = datetime.clone().set({ hour, minute });
                        const timeStr = time.format(TIME_FORMAT);
                        return (
                            <option
                                key={ timeStr }
                                value={ timeStr }
                                disabled={ time.isAfter(max) || time.isBefore(min) }
                            >
                                {timeStr}
                            </option>
                        );
                    })
                )}
            </FormControl>
        </div>
    );
}

CombinedTimeSelector.propTypes = {
    datetime: MomentPropTypes.isMoment,
    minuteStep: PropTypes.number,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    min: MomentPropTypes.isMoment,
    max: MomentPropTypes.isMoment,
    ariaLabel: PropTypes.string,
};

CombinedTimeSelector.defaultProps = {
    datetime: trainTime(),
    minuteStep: 15,
    onChange: _.noop,
    disabled: false,
    min: null,
    max: null
};

export default CombinedTimeSelector;



// WEBPACK FOOTER //
// ./src/components/search/dates/CombinedTimeSelector.js